const TTL_MS = 30_000;

interface CacheEntry {
  request: Promise<unknown>;
  expiresAt: number;
}

const requests = new Map<string, CacheEntry>();

export function cached<T>(key: string, fetch: () => Promise<T>): Promise<T> {
  const entry = requests.get(key);
  if (entry && Date.now() < entry.expiresAt) {
    return entry.request as Promise<T>;
  }

  const request: Promise<T> = fetch().then(
    (value) => {
      if (requests.get(key)?.request === request) {
        requests.set(key, { request, expiresAt: Date.now() + TTL_MS });
      }
      return value;
    },
    (error) => {
      if (requests.get(key)?.request === request) {
        requests.delete(key);
      }
      throw error;
    },
  );

  requests.set(key, { request, expiresAt: Infinity });

  return request;
}

export function invalidate(key: string): void {
  requests.delete(key);
}

export function clear(): void {
  requests.clear();
}
